// Matches DateTime.kt: parse/format using UTC ISO with millis
// ("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'").

export function toStampMs(input: string | null | undefined): number {
  if (!input) return 0;
  const ms = Date.parse(input);
  return Number.isNaN(ms) ? 0 : ms;
}

export function toIsoUtc(ms: number): string {
  // Date.toISOString() already yields "yyyy-MM-ddTHH:mm:ss.SSSZ" in UTC.
  return new Date(ms).toISOString();
}

export function nowMs(): number {
  return Date.now();
}
